import merge from 'lodash/merge';
export const _merge = merge;
